const {
  appendPath
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
 * Writes the selection from the Add Pass button to the collection of Weld Passes.
 *
 * @function evalute - evaluate ucbWeldPassTypeSelectBehavior
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const {
    selection = {}
  } = transientContext;
  const [key] = Object.keys(selection);
  if (key === undefined) {
    return;
  }
  const targetContentPath = appendPath('/weldPasses', key);
  const writeSource = {
    type: 'writeContentBehavior',
    targetContentPath,
    source: selection[key]
  };
  await sourceEvaluator(writeSource);
};
module.exports = {
  evaluate
};